/// <reference path="../../app.definition.ts" />

import { CachedItem } from "./_cachedItem";
import { Subject } from "./subject";

export class CachedSubject extends CachedItem {
    subjectId: number;
    ownerId: number;
    firstName: string;
    lastName: string;
    providerIdentity: string;
    birthDate: number;
    photo: string;
    isFrozen: boolean;
    frozenDate: Date;
    isFormerTeamMember: boolean;
    exitDate: Date;
    bgColor: string;
    teamOrgId: number;
    subjectTypeId: string;
    teamOrgShortName: string;
    teamPartyId: number;
    coCaptain: boolean = false;    
    isTeamMember: boolean = false; // user is team member    
    isActiveMember: boolean = false; // user is team member but not former
    gender: string;
    uniqueId: string;
    teamId: number;
    projectName: string;
    projectDescription: string;

    deserialize(input: Subject): CachedSubject {
        !!input.subjectId && (this.subjectId = input.subjectId);
        !!input.firstName && (this.firstName = input.firstName);
        !!input.lastName && (this.lastName = input.lastName);
        !!input.ownerId && (this.ownerId = input.ownerId);
        !!input.photo && (this.photo = input.photo);
        !!input.birthDate && (this.birthDate = input.birthDate);
        !!input.isFrozen && (this.isFrozen = input.isFrozen);
        !!input.frozenDate && (this.frozenDate = input.frozenDate);
        !!input.isFormerTeamMember && (this.isFormerTeamMember = input.isFormerTeamMember);
        !!input.exitDate && (this.exitDate = input.exitDate);
        !!input.bgColor && (this.bgColor = input.bgColor);
        !!input.subjectTypeId && (this.subjectTypeId = input.subjectTypeId);
        !!input.teamOrgId && (this.teamOrgId = input.teamOrgId);
        input.teamOrgShortName && (this.teamOrgShortName = input.teamOrgShortName);
        !!input.teamPartyId && (this.teamPartyId = input.teamPartyId);
        !!input.coCaptain && (this.coCaptain = input.coCaptain);
        !!input.isTeamMember && (this.isTeamMember = input.isTeamMember);
        !!input.isActiveMember && (this.isActiveMember = input.isActiveMember);
        !!input.gender && (this.gender = input.gender);
        !!input.uniqueId && (this.uniqueId = input.uniqueId);
        input.teamId && (this.teamId = input.teamId);
        !!input.projectName && (this.projectName = input.projectName);
        !!input.projectDescription && (this.projectDescription = input.projectDescription);
        super.deserialize(input);
        return this;
    }

    constructor() {
        super();
    }

    public static from(item: any) {
        return new CachedSubject().deserialize(item);
    }
}
